import { initializeApp } from "firebase/app";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "YOUR_PROJECT.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://YOUR_PROJECT.firebaseio.com",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "000000000000",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:000:web:000000",
};

export const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

const useEmulator = process.env.REACT_APP_USE_EMULATOR === "true";
if (useEmulator) {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export const calendarAuth = httpsCallable(functions, "calendarAuth");
export const getCalendarStatus = httpsCallable(functions, "getCalendarStatus");
export const syncCalendar = httpsCallable(functions, "syncCalendar");
export const getCalls = httpsCallable(functions, "getCalls");
export const getCall = httpsCallable(functions, "getCall");
export const reTranscribeCall = httpsCallable(functions, "reTranscribeCall");
export const recalculateMetrics = httpsCallable(functions, "recalculateMetrics");
export const getKeywords = httpsCallable(functions, "getKeywords");
export const updateKeywords = httpsCallable(functions, "updateKeywords");
export const scanUpcomingMeetings = httpsCallable(functions, "scanUpcomingMeetings");
export const confirmMeetingSelection = httpsCallable(functions, "confirmMeetingSelection");
export const skipScheduledCall = httpsCallable(functions, "skipScheduledCall");
export const updateLocale = httpsCallable(functions, "updateLocale");
export const getLocaleSettings = httpsCallable(functions, "getLocaleSettings");
export const getMetrics = httpsCallable(functions, "getMetrics");
export const sendBotToMeeting = httpsCallable(functions, "sendBotToMeeting");
export const getUserProfile = httpsCallable(functions, "getUserProfile");
export const createTeam = httpsCallable(functions, "createTeam");
export const getInviteLink = httpsCallable(functions, "getInviteLink");
export const joinTeam = httpsCallable(functions, "joinTeam");
export const getTeamMembers = httpsCallable(functions, "getTeamMembers");
export const updateMemberRole = httpsCallable(functions, "updateMemberRole");
export const removeTeamMember = httpsCallable(functions, "removeTeamMember");
export const updateTeamName = httpsCallable(functions, "updateTeamName");
export const getTeamLeaderboard = httpsCallable(functions, "getTeamLeaderboard");
export const getTeamReports = httpsCallable(functions, "getTeamReports");
export const getTeamCall = httpsCallable(functions, "getTeamCall");
export const getMemberCalls = httpsCallable(functions, "getMemberCalls");
export const getMemberMetrics = httpsCallable(functions, "getMemberMetrics");
export const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
export const captureSubscription = httpsCallable(functions, "captureSubscription");
export const cancelSubscription = httpsCallable(functions, "cancelSubscription");
export const getSubscriptionStatus = httpsCallable(functions, "getSubscriptionStatus");
export const getPlanLimits = httpsCallable(functions, "getPlanLimits");
export const checkCallAllowed = httpsCallable(functions, "checkCallAllowed");
